export enum PurchaseOrderStatus {
  DRAFT = 'DRAFT',
  READY = 'READY',
  REQUESTING = 'REQUESTING',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  FULFILLED = 'FULFILLED',
  ORDER_DETAIL_FULFILLED = 'ORDER_DETAIL_FULFILLED',
}
